<template>
  <div class="dropdown-center">
    <button
      id="dropdowLeaseItNowFilterBrand"
      class="form-select form-select-multiselect"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      <div v-if="selected.length" class="form-select-wrapper">
        <div>
          <ul class="b-options-badges">
            <li v-for="item in selected" :key="item">
              <div
                class="e-option-badge"
                :title="getOptionText(item)"
                @click.stop="onClickBadge(item)">
                <span>{{ getOptionText(item) }}</span>
                <i class="icon-close"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-else>{{ dictionary.brandPlaceholder }}</div>
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdowLeaseItNowFilterBrand">
      <div class="b-fleet-filters" @click.stop>
        <div class="mb-20">
          <input
            ref="searchTerm"
            v-model="searchTerm"
            type="search"
            name="search"
            class="form-control form-control-search form-control-short"
            :placeholder="dictionary.searchTermPlaceholder" />
        </div>

        <div class="b-fleet-filters__body">
          <ul>
            <li
              v-for="item in optionsFiltered"
              :key="item.value"
              style="position: relative">
              <input
                :id="'brand' + item.value"
                v-model="selected"
                class="form-check-input"
                autocomplete="off"
                type="checkbox"
                :value="item.value"
                :disabled="isDisabled(item.value)"
                @change="onChange" />
              <label
                class="form-check-label"
                :for="'brand' + item.value"
                @click.stop>
                {{ item.text }}
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinsLeaseItNow from './../../mixins/leaseitnow-mixins'
/* eslint-disable no-unused-vars */
import { remove } from 'lodash'
import constants from './../../../lib/constants'
const { filters } = constants.leaseitnow
import { Dropdown } from 'bootstrap'

export default {
  mixins: [mixinsLeaseItNow],
  props: {
    options: {
      required: true,
      type: Array,
    },
  },
  emits: ['change-selected'],
  data() {
    return {
      maxItems: 4,
      searchTerm: '',
    }
  },
  computed: {
    selected: {
      get: function () {
        return this.options.length ? this.getField(filters.brands) : []
      },
      set: function (value) {
        this.setField({ field: filters.brands, value })
        // prettier-ignore
        const args = value.map((x) => this.options.find((i) => i.value === x).apiObject)
        this.setField({ field: `${filters.brands}Args`, value: args })
      },
    },

    optionsFiltered() {
      if (!this.searchTerm) {
        return this.options
      }

      return this.options.filter((x) =>
        x.text.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    },
  },
  mounted() {
    document
      .getElementById('dropdowLeaseItNowFilterBrand')
      .addEventListener('shown.bs.dropdown', () => {
        this.$refs.searchTerm.focus()
      })
  },
  methods: {
    isDisabled(value) {
      if (this.selected.length <= this.maxItems - 1) {
        return false
      }

      return !this.selected.includes(value)
    },

    onClickBadge(value) {
      /* eslint-disable no-undef */
      this.selected = _.remove(this.selected, (x) => x !== value)
      this.$emit('change-selected')
      this.dropDownHide()
    },

    getOptionText(value) {
      return this.options.length
        ? this.options.find((i) => i.value === value).text
        : null
    },

    onChange() {
      console.log('FilterBrand onChange')
      this.$emit('change-selected')
    },

    dropDownHide() {
      document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((i) => {
        new Dropdown(i).hide()
      })
    },
  },
}
</script>

<style scoped lang="scss">
.b-fleet-filters {
  &__body {
    max-height: 270px;
    overflow: auto;
  }
}
</style>
